import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Header from '../../components/ui/Header';
import WhatsAppWidget from '../../components/ui/WhatsAppWidget';
import NewsletterSubscription from '../../components/ui/NewsletterSubscription';
import ConsultationBooking from '../../components/ui/ConsultationBooking';
import HeroSection from './components/HeroSection';
import ServicePreview from './components/ServicePreview';
import VideoIntroduction from './components/VideoIntroduction';
import TestimonialHighlights from './components/TestimonialHighlights';
import FacebookVideoTestimonials from './components/FacebookVideoTestimonials';

const HomeLanding = () => {
  const navigate = useNavigate();

  const handleHireClick = () => {
    navigate('/contact-hub');
  };

  const handleContactClick = () => {
    navigate('/contact-hub');
  };

  const handleServiceClick = (serviceId) => {
    navigate('/services-portfolio', { state: { serviceId } });
  };

  const pageVariants = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="min-h-screen bg-background"
    >
      <Header />
      <main className="smooth-scroll">
        <HeroSection 
          onHireClick={handleHireClick}
          onContactClick={handleContactClick}
        />
        
        <ServicePreview onServiceClick={handleServiceClick} />
        
        <VideoIntroduction />
        
        <TestimonialHighlights />
        
        <FacebookVideoTestimonials />
        
        {/* Newsletter & Consultation Section */}
        <section className="py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-gradient-to-b from-card to-background">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 lg:gap-12">
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <NewsletterSubscription />
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <ConsultationBooking />
              </motion.div>
            </div>
          </div>
        </section>
      </main>
      {/* Footer Text */}
      <footer className="py-6 px-4 bg-background border-t border-border">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-sm text-muted-foreground">
            Powered by <span className="font-semibold text-foreground">Ebass Group</span> - Designed with Purpose and Precision
          </p>
        </div>
      </footer>
      <WhatsAppWidget />
    </motion.div>
  );
};

export default HomeLanding;